import { render, staticRenderFns } from "./loss.vue?vue&type=template&id=bb3a51f2&scoped=true&"
import script from "./loss.vue?vue&type=script&lang=js&"
export * from "./loss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a51f2",
  null
  
)

export default component.exports